export const frontmatter = {
    "draft": false,
    "title": "Administration",
    "description": "OnnIA platform administration: organizations, teams, plans, and system configuration.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 0
}

export const toc = []